export const OTHER_PROVIDER_SENTINEL = '__other__';
export const OTHER_PROVIDER_PREFIX = 'Other: ';
export const OTHER_CATEGORIES = ['EU Open Source', 'Non-EU Open Source', 'EU Provider (Proprietary)', 'Non-EU Provider (Proprietary)'] as const;
export type OtherCategory = typeof OTHER_CATEGORIES[number];

export function isOtherProvider(name: string): boolean {
  return name.startsWith(OTHER_PROVIDER_PREFIX);
}

export function getOtherCategory(name: string): OtherCategory | null {
  if (!isOtherProvider(name)) return null;
  const cat = name.substring(OTHER_PROVIDER_PREFIX.length);
  return OTHER_CATEGORIES.includes(cat as OtherCategory) ? (cat as OtherCategory) : null;
}

export function buildOtherProviderName(category: OtherCategory): string {
  return `${OTHER_PROVIDER_PREFIX}${category}`;
}
